import React from 'react';
import styled from 'styled-components';
import { get } from 'lodash';
import { ReactComponent as BaseVSign } from '../../assets/BookingBoard/confirmed-big.svg';
import { ReactComponent as BaseWarningSign } from '../../assets/warning-yellow.svg';
import { Tooltip } from '../Tooltip';

const WarningSign = styled(BaseWarningSign)`
  height: 24px;
  width: 24px;
`;

const VSign = styled(BaseVSign)`
  height: 20px;
  width: 20px;
`;

const Wrapper = styled.div`
  width: 100%;
  gap: 8px;
  display: flex;
  align-items: center;
`;

const VSignWrapper = styled.div`
  visibility: ${({ $isVisible }) => ($isVisible ? 'visible' : 'hidden')};
`;

const CheckedWithWarning = ({
  rowData,
  dataKey,
  columnData: { value: defaultValue, tooltip } = {},
  isWarning = false,
  warningTooltip = ''
}) => {
  const value = get(rowData, dataKey);

  return (
    <Wrapper>
      <VSignWrapper $isVisible={defaultValue || value}>
        <Tooltip body={tooltip} disabled={!tooltip}>
          <VSign />
        </Tooltip>
      </VSignWrapper>
      {isWarning && (
        <Tooltip body={warningTooltip} disabled={!warningTooltip}>
          <WarningSign />
        </Tooltip>
      )}
    </Wrapper>
  );
};

export default CheckedWithWarning;
